import { render } from "./UiStar.vue?vue&type=template&id=633c1363&scoped=true"
import script from "./UiStar.vue?vue&type=script&lang=js"
export * from "./UiStar.vue?vue&type=script&lang=js"

import "./UiStar.vue?vue&type=style&index=0&id=633c1363&scoped=true&lang=css"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-633c1363"]])

export default __exports__